import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Build_consistencyIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_consistency.svg';
import { ReactComponent as Improve_strengthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_strength.svg';
import { ReactComponent as Balanced_fitnessIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/balanced_fitness.svg';
import { ReactComponent as Improve_staminaIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_stamina.svg';
import { ReactComponent as Feel_healthierIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/feel_healthier.svg';
import { ReactComponent as Move_betterIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness-move_better.svg';

interface GeneralFitnessStep1Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  build_consistency: <Build_consistencyIcon />,
  improve_strength: <Improve_strengthIcon />,
  improve_stamina: <Improve_staminaIcon />,
  move_better: <Move_betterIcon />,
  feel_healthier: <Feel_healthierIcon />,
  balanced_fitness: <Balanced_fitnessIcon />,
};

// What should general fitness mean for this client?
export const GeneralFitnessStep1: FC<GeneralFitnessStep1Props> = ({ value, onNext }) => {
  const [selectedFitnessMean, setSelectedFitnessMean] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalDetails?.groups?.find(
    (g: any) => g.goalId === 'general_fitness',
  );

  const meanings = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div className="goal-buttons">
        {meanings.map((meaning: any) => (
          <button
            key={meaning.id}
            className={`goal-btn ${selectedFitnessMean === meaning.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedFitnessMean(meaning.slug);
              if (onNext) onNext(meaning.slug);
            }}
          >
            <div className="goal-icon">{iconMap[meaning.id]}</div>
            <span className="goal-label">{meaning.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
